import {
  Button,
  Card,
  CardActions,
  CardContent, CardHeader,
  Divider,
  FormControl, InputLabel,
  Modal,
  Select,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  fieldsComboMEG: {
    margin: theme.spacing(0),
    display: 'flex',
  }
}));

function Bakim({ open, onClose, className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [MEGTanimNedeni, setMEGTanimNedeni] = React.useState(0);
  const [MEGTanimYil,setMEGTanimYil] = React.useState(0);
  const [MEGTanimNedenleri, setMEGTanimNedenleri] = useState([]);
  const [MEGBasvuruYil, setMEGBasvuruYil] = useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');

  const SessionUser = getUser();
  let FisData = readonly ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : loadBaslandiJob();

   if (!readonly && (!FisData || FisData.length === 0)) {
      const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
      if (current) {
        saveBaslandiJob(current);
        FisData = loadBaslandiJob();
      }
    }
  


  let Fis_No = FisData[0]?.FisNo;
  let TEKNISYEN_KODU = SessionUser.TechnicianId;

  const GetArtemisMEGBasvuruNedeni = () => {
    axios.get(`/GetArtemisMEGBasvuruNedeni`)
      .then(response => {
        if (response.data.length > 0) {
          setMEGTanimNedenleri(response.data);
        }
      })

  }

  const GetArtemisMEGYil = () => {
    axios.get(`/GetArtemisMEGYil`)
      .then(response => {
        if (response.data.length > 0) {
          setMEGBasvuruYil(response.data);
        }
      })
  }

  const handleSave = (MEGTanimNedeni,MEGTanimYil) => {
    axios.get(`/SetArtemisMEGBasvuru/${Fis_No}/${MEGTanimNedeni}/${MEGTanimYil}/${TEKNISYEN_KODU}`)
    .then((response) => {
      const res = response.data[0];
      if (parseInt(res.ErrorCode) === 1000) {
        setUyari(true);
        setUyariTip('success');
        setUyariAciklama(res.ErrorDescription)
        } else {
        setUyari(true);
        setUyariTip('error');
        setUyariAciklama(res.ErrorDescription)
      }
    })
  }

  useEffect(() => {
    if (FisData === undefined || FisData[0] === undefined) {
      return;
    }
    GetArtemisMEGBasvuruNedeni();
    GetArtemisMEGYil();
  }, [FisData]);

  const handleChangeMemnuniyetEkGarantiTipi = (e) => {
    setMEGTanimNedeni(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      MEG_TANIMLAMA_NEDENI: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeMemnuniyetEkGarantiYil = (e) => {
    setMEGTanimYil(e.target.value || '');
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      MEG_TANIMLAMA_YIL: e.target.value || '',
    };
    saveBaslandiJob(job);
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };




  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card className={clsx(classes.root, className)}
      >
        <CardHeader title={"Memnuniyet EkGaranti Teklif"} />
        {uyari ? (
        <Alert
          onClose={uyariKapat}
          open={uyari}
          message={uyariAciklama || ''}
          variant={uyariTip}
        />
      ) : (
        <div></div>
      )}
        <Divider />
        <CardContent className={classes.content}>
          <Typography className={classes.title} color="textSecondary">
           Ürün Değişimi Önlemek Amaçlı Ek Garanti hizmetini seçtiniz. Lütfen MEG tanımlama nedenini seçiniz!.
          </Typography>
          <br />
          <Divider className={classes.dividerDegisim} />
          <Typography variant="h6" component="h2" gutterBottom>
            <FormControl variant="outlined" className={classes.fieldsComboMEG}>
              <InputLabel
                id="demo-simple-select-outlined-label"
                disabled={readonly}
              >
                {"MEG Tanımlama Nedeni"}
              </InputLabel>
              <Select
                fullWidth
                native
                labelId="demo-simple-select-outlined-label"
                label="MEG Tanımlama Nedeni"
                id="demo-simple-select-outlined"
                value={MEGTanimNedeni}
                onChange={handleChangeMemnuniyetEkGarantiTipi}
                disabled={readonly}
              >
                <option aria-label="None" value="" />
                {MEGTanimNedenleri?.map(p => {
                  return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
                })}
              </Select>
            </FormControl>
          </Typography>
          {
            MEGTanimNedeni !== 0 ? (
              <Typography variant="h6" component="h2" gutterBottom>
                <FormControl variant="outlined" className={classes.fieldsComboMEG}>
                  <InputLabel
                    id="demo-simple-select-outlined-label"
                    disabled={readonly}
                  >
                    {"MEG Yıl"}
                  </InputLabel>
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    label="MEG Yıl"
                    id="demo-simple-select-outlined"
                    value={MEGTanimYil}
                    onChange={handleChangeMemnuniyetEkGarantiYil}
                    disabled={readonly}
                  >
                    <option aria-label="None" value="" />
                    {MEGBasvuruYil?.map(p => {
                      return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
                    })}
                  </Select>
                </FormControl>
              </Typography>
            )
              : null
          }
        </CardContent>
        <CardActions className={classes.actions}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              onClose();
              handleSave(MEGTanimNedeni,MEGTanimYil);
            }}
            disabled={MEGTanimNedeni === 0 || MEGTanimYil === 0}>
            Kaydet
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
             return;
            }}>
            İptal
          </Button>
        </CardActions>
      </Card >
    </Modal >
  );
}

Bakim.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(Bakim);
